import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { NgClass } from '@angular/common';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-switch',
  imports: [NgClass, FormsModule],
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SwitchComponent),
    },
  ],
})
export class SwitchComponent implements ControlValueAccessor {
  @Input() name: string = '';
  @Input() value?: string | number;
  @Input() disabled: boolean = false;
  @Input() box?: 'light' | 'dark';
  @Input('size') size?: 'small' | 'medium';
  @Input('title-left') titleLeft?: string;
  @Input('title-right') titleRight?: string;
  @Input() type: 'default' | 'on-off' = 'default';
  @Input('border-radius') borderRadius: 'default' | 'large' = 'default';
  @Input() active?: boolean;
  @Output() activeChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public onChange = (value: boolean) => {};
  public onTouched = (value: boolean) => {};

  change(): void {
    if (this.disabled) return;
    this.onChange(this.active ?? false);
    this.activeChange.emit(this.active);
  }

  focus(): void {
    this.onTouched(true);
  }

  writeValue(obj: boolean): void {
    this.active = obj;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: (value: boolean) => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
